"use strict";

exports.__esModule = true;
exports.NAMESPACE_STATE_DEFAULT = exports.FIELD_STATE_DEFAULT = exports.FIELD_KEY_VALUE_ON_FOCUS = exports.FIELD_KEY_VALUE = exports.FIELD_KEY_VALID = exports.FIELD_KEY_TOUCHED = exports.FIELD_KEY_FOCUS = exports.FIELD_KEY_ERROR = exports.FIELD_KEY_DIRTY = exports.FIELD_KEY_DEFAULT_VALUE_ERROR = exports.FIELD_KEY_DEFAULT_VALUE = exports.FIELD_INITIAL_STATIC_VALUES = exports.FIELD_DEFAULT_VALUE_ON_FOCUS = exports.FIELD_DEFAULT_VALUE = exports.FIELD_DEFAULT_VALID = exports.FIELD_DEFAULT_TOUCHED = exports.FIELD_DEFAULT_FOCUS = exports.FIELD_DEFAULT_ERROR = exports.FIELD_DEFAULT_DIRTY = exports.FIELD_DEFAULT_DEFAULT_VALUE_ERROR = exports.FIELD_DEFAULT_DEFAULT_VALUE = void 0;

var _FIELD_INITIAL_STATIC;

var FIELD_DEFAULT_DEFAULT_VALUE = undefined;
exports.FIELD_DEFAULT_DEFAULT_VALUE = FIELD_DEFAULT_DEFAULT_VALUE;
var FIELD_DEFAULT_DEFAULT_VALUE_ERROR = undefined;
exports.FIELD_DEFAULT_DEFAULT_VALUE_ERROR = FIELD_DEFAULT_DEFAULT_VALUE_ERROR;
var FIELD_DEFAULT_DIRTY = false;
exports.FIELD_DEFAULT_DIRTY = FIELD_DEFAULT_DIRTY;
var FIELD_DEFAULT_ERROR = null;
exports.FIELD_DEFAULT_ERROR = FIELD_DEFAULT_ERROR;
var FIELD_DEFAULT_FOCUS = false;
exports.FIELD_DEFAULT_FOCUS = FIELD_DEFAULT_FOCUS;
var FIELD_DEFAULT_TOUCHED = false;
exports.FIELD_DEFAULT_TOUCHED = FIELD_DEFAULT_TOUCHED;
var FIELD_DEFAULT_VALID = true;
exports.FIELD_DEFAULT_VALID = FIELD_DEFAULT_VALID;
var FIELD_DEFAULT_VALUE = '';
exports.FIELD_DEFAULT_VALUE = FIELD_DEFAULT_VALUE;
var FIELD_DEFAULT_VALUE_ON_FOCUS = null;
exports.FIELD_DEFAULT_VALUE_ON_FOCUS = FIELD_DEFAULT_VALUE_ON_FOCUS;
var FIELD_STATE_DEFAULT = {};
exports.FIELD_STATE_DEFAULT = FIELD_STATE_DEFAULT;
Object.freeze(FIELD_STATE_DEFAULT);
var NAMESPACE_STATE_DEFAULT = {};
exports.NAMESPACE_STATE_DEFAULT = NAMESPACE_STATE_DEFAULT;
Object.freeze(NAMESPACE_STATE_DEFAULT); // Symbol keys are normally only for internal use, these will be hidden as field prop

var FIELD_KEY_DEFAULT_VALUE = Symbol('defaultValue');
exports.FIELD_KEY_DEFAULT_VALUE = FIELD_KEY_DEFAULT_VALUE;
var FIELD_KEY_DEFAULT_VALUE_ERROR = Symbol('defaultValueError');
exports.FIELD_KEY_DEFAULT_VALUE_ERROR = FIELD_KEY_DEFAULT_VALUE_ERROR;
var FIELD_KEY_DIRTY = 'dirty';
exports.FIELD_KEY_DIRTY = FIELD_KEY_DIRTY;
var FIELD_KEY_ERROR = 'error';
exports.FIELD_KEY_ERROR = FIELD_KEY_ERROR;
var FIELD_KEY_FOCUS = 'focus';
exports.FIELD_KEY_FOCUS = FIELD_KEY_FOCUS;
var FIELD_KEY_TOUCHED = 'touched';
exports.FIELD_KEY_TOUCHED = FIELD_KEY_TOUCHED;
var FIELD_KEY_VALID = 'valid';
exports.FIELD_KEY_VALID = FIELD_KEY_VALID;
var FIELD_KEY_VALUE = 'value';
exports.FIELD_KEY_VALUE = FIELD_KEY_VALUE;
var FIELD_KEY_VALUE_ON_FOCUS = Symbol('valueOnFocus');
exports.FIELD_KEY_VALUE_ON_FOCUS = FIELD_KEY_VALUE_ON_FOCUS;
var FIELD_INITIAL_STATIC_VALUES = (_FIELD_INITIAL_STATIC = {}, _FIELD_INITIAL_STATIC[FIELD_KEY_DIRTY] = FIELD_DEFAULT_DIRTY, _FIELD_INITIAL_STATIC[FIELD_KEY_FOCUS] = FIELD_DEFAULT_DIRTY, _FIELD_INITIAL_STATIC[FIELD_KEY_TOUCHED] = FIELD_DEFAULT_DIRTY, _FIELD_INITIAL_STATIC[FIELD_KEY_VALUE_ON_FOCUS] = FIELD_DEFAULT_VALUE_ON_FOCUS, _FIELD_INITIAL_STATIC[FIELD_KEY_DEFAULT_VALUE] = FIELD_DEFAULT_DEFAULT_VALUE, _FIELD_INITIAL_STATIC[FIELD_KEY_DEFAULT_VALUE_ERROR] = FIELD_DEFAULT_DEFAULT_VALUE_ERROR, _FIELD_INITIAL_STATIC);
exports.FIELD_INITIAL_STATIC_VALUES = FIELD_INITIAL_STATIC_VALUES;